import React from 'react';
import { Link } from 'react-router-dom';
import { BiLeftArrow } from 'react-icons/bi';

function ThankYoupage() {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    padding: '20px 30px',
    maxWidth: '500px',
    textAlign: 'center',
    fontFamily: "'Arial', sans-serif",
    color: '#333',
    transition: 'transform 0.3s ease-in-out',
  };

  const headingStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#0078d7',
    marginBottom: '15px',
  };

  const messageStyle = {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#555',
    marginBottom: '20px',
  };

  const trialMessageStyle = {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#2e7d32',
    fontWeight: '600',
    margin: '15px 0',
    padding: '10px',
    backgroundColor: '#e8f5e9',
    borderRadius: '5px',
  };

  const buttonStyle = {
    backgroundColor: '#0078d7',
    color: '#ffffff',
    border: 'none',
    borderRadius: '5px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    transition: 'background-color 0.3s ease',
    marginTop: '15px',
    textDecoration: 'none',
    display: 'inline-block',
  };

  const buttonHoverStyle = {
    backgroundColor: '#005bb5',
  };

  // Calculate the trial end date (7 days from now)
  const trialEndDate = new Date();
  trialEndDate.setDate(trialEndDate.getDate() + 7);
  const formattedTrialEndDate = trialEndDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <h2 style={headingStyle}>Registration Successful!</h2>
        <p style={messageStyle}>
          Your school has been successfully registered with our system.
        </p>
        
        <div style={trialMessageStyle}>
          <p>You can now login and use the system for <strong>FREE</strong> until</p>
          <p><strong>{formattedTrialEndDate}</strong></p>
          <p>After this period, you can continue by subscribing to one of our plans.</p>
        </div>

        <p style={messageStyle}>
          If you need any assistance, please contact our support team.
        </p>

        <Link 
          to="/" 
          style={buttonStyle}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = buttonHoverStyle.backgroundColor;
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = buttonStyle.backgroundColor;
          }}
        >
          Continue to Login
        </Link>
      </div>
    </div>
  );
}

export default ThankYoupage;